import { topicsData, ITopic } from 'config/topics';
import { UPDATE_TOPIC, UPDATE_TOPIC_CONTENT_VISIBILITY } from 'redux/actions/topicAction';

const initialState = {
  contentVisible: false,
  selected: topicsData[0],
};

type TopicState = typeof initialState;

export type ITopicAction = 
 | { type: typeof UPDATE_TOPIC; payload: ITopic }
 | { type: typeof UPDATE_TOPIC_CONTENT_VISIBILITY; payload: boolean }

export const topicReducer = (state: TopicState = initialState, action: ITopicAction): TopicState => {
  switch (action.type) {
    case UPDATE_TOPIC:
      return { 
        ...state,
        selected: action.payload,
        contentVisible: true
      };
    case UPDATE_TOPIC_CONTENT_VISIBILITY:
      return { 
        ...state,
        contentVisible: action.payload
      };
    default:
      return state;
  }
};
